import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { faBars, faTv, faBurger, faFilm, faClipboardList, faHandHoldingDollar, faHome, faTimes } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import useUserStore from '../../hooks/useUserStore';
import { logoutApi, getMe } from '../../api/auth';
import OutsideAlerter from '../../hooks/useOutsideAlerter';
import './Navbar.css';

const UserBox = () => {
  const user = useUserStore((state) => state.user);
  const logout = useUserStore((state) => state.logout);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  console.log(user)

  const handleLogout = () => {
    logoutApi().finally(() => {
      logout();
      navigate('/');
    });
  };
  const [rotation, setRotation] = useState({ transform: 'rotate(0deg)' });

  useEffect(() => {
    if (open) {
      setRotation({ transform: 'rotate(180deg)' });
    } else {
      setRotation({ transform: 'rotate(0deg)' });
    }
  }, [open]);

  return (
    <OutsideAlerter onAlert={() => setOpen(false)}>
      <button
        type='button'
        id='menu-button'
        aria-expanded='true'
        aria-haspopup='true'
        className='flex gap-2 h-14 p-2 rounded-lg bg-white m-auto font-montserrat font-semibold text-gray-400 user-box transition-all'
        onClick={() => setOpen(!open)}
      >
        <img src={user?.avatar ? user.avatar : '/avatar.png'} alt='User avatar' className='w-8 h-8 my-auto' />
        <span className='my-auto'>{user?.name}</span>
        <FontAwesomeIcon icon={faCaretDown} size='xl' className='my-auto hover:text-red-2 transition-transform' style={rotation} />
      </button>
      <div
        className='flex-col font-montserrat font-semibold text-red-1 absolute transition-all z-10 rounded-md bg-white shadow-lg p-2 focus:outline-none'
        style={open ? { display: 'flex' } : { display: 'none' }}
      >
        <Link to='/perfil' className='hover:text-red-2'>
          Mi perfil
        </Link>
        {user?.role === 'admin' && (
          <Link to='/administracion' className='hover:text-red-2'>
            Administración
          </Link>
        )}
        <button onClick={handleLogout} className='hover:text-red-2 text-left'>
          Cerrar sesión
        </button>
      </div>
    </OutsideAlerter>
  );
};

const Navbar = ({ children, className }) => {
  // is scroll at top
  const [isTop, setIsTop] = useState(true);
  const [navbarOpen, setNavbarOpen] = useState(false);
  const [slide, setSlide] = useState(false);
  const [url, setUrl] = useState('/');
  const location = useLocation();

  const userData = useUserStore((state) => state.user);
  const storeLogin = useUserStore((state) => state.login);
  const storeLogout = useUserStore((state) => state.logout);

  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      getMe()
        .then((res) => {
          const user = res.data.data?.name ? res.data.data : res.data.user || res.data;
          storeLogin(user, storedToken);
        })
        .catch(() => {
          storeLogout();
        });
    }
  }, []);

  useEffect(() => {
    setUrl(location.pathname);
  }, [location]);

  useEffect(() => {
    document.addEventListener('scroll', () => {
      // const isTop = window.scrollY < 100;
      if (window.scrollY < 100) {
        setIsTop(true);
      } else {
        setIsTop(false);
      }
    });
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setSlide(navbarOpen);
    }, 100);
  }, [navbarOpen]);

  return (
    <nav className={'flex sticky top-0 z-20 bg-white h-20 backdrop-blur-md max-w-[100vw]' + (isTop ? '' : 'shadow-xl bg-opacity-80')}>
      <div className='min-w-[20%] h-full flex items-center justify-center '>
        <img src='/logo.png' alt='Turkish4love Logo' className='w-auto h-14' />
      </div>
      <div className='hidden lg:flex justify-center min-w-[60%]'>
        <div className='flex justify-around items-center m-auto min-w-[100%] text-2xl text-rose-950'>
          <Link
            to='/'
            className={
              'link transition-colors p-2 px-4 rounded-xl hover:text-red-1 hover:bg-opacity-5 hover:bg-red-2 ' + (url === '/' && 'text-red-1')
            }
          >
            Inicio
          </Link>

          <Link
            to='/series'
            className={
              'link transition-colors p-2 px-4 rounded-xl hover:text-red-1 hover:bg-opacity-5 hover:bg-red-2 ' + (url === '/series' && 'text-red-1')
            }
          >
            Series
          </Link>

          <Link
            to='/peliculas'
            className={
              'link transition-colors p-2 px-4 rounded-xl hover:text-red-1 hover:bg-opacity-5 hover:bg-red-2 ' +
              (url === '/peliculas' && 'text-red-1')
            }
          >
            Películas
          </Link>

          <Link
            to='/reglas'
            className={
              'link transition-colors p-2 px-4 rounded-xl hover:text-red-1 hover:bg-opacity-5 hover:bg-red-2 ' + (url === '/reglas' && 'text-red-1')
            }
          >
            Reglas
          </Link>

          <Link
            to='/donaciones'
            className={
              'link transition-colors p-2 px-4 rounded-xl hover:text-red-1 hover:bg-opacity-5 hover:bg-red-2 ' +
              (url === '/donaciones' && 'text-red-1')
            }
          >
            Donaciones
          </Link>
        </div>
      </div>
      <div className='hidden lg:flex items-center justify-center min-w-[20%] relative'>{userData?.name ? <UserBox/>: null}</div>
      <div className='flex w-4/5 lg:hidden '>
        <button
          className='ml-auto mr-3 p-2 my-auto rounded-xl hover:bg-gray-300 bg-opacity-25 transition-all h-fit'
          onClick={() => setNavbarOpen(true)}
        >
          <FontAwesomeIcon icon={faBars} className='text-4xl text-red-2' />
        </button>
      </div>
      <div
        className={
          'lg:hidden absolute top-0 left-0 z-100 h-[100vh] w-screen bg-black bg-opacity-50  transition-all ' + (navbarOpen ? 'flex' : 'hidden')
        }
      >
        <div className='w-full' />
        <div className={'min-w-[75%] bg-white slide transition-all ' + (slide ? '' : 'translate-x-full')}>
          <div className='m-3 p-2 rounded-xl ml-auto mr-3 w-fit hover:bg-gray-300 bg-opacity-25 transition-all' onClick={() => setNavbarOpen(false)}>
            <FontAwesomeIcon icon={faTimes} className='text-4xl text-red-2' />
          </div>
          <div className='flex flex-col p-5 text-2xl font-montserrat font-semibold gap-5 text-red-1'>
            <Link onClick={() => setNavbarOpen(false)} to='/' className={'p-2 bg-opacity-25 rounded-lg ' + (url === '/' && 'bg-red-2')}>
              <FontAwesomeIcon icon={faHome} size='xs' />
              &nbsp;&nbsp;Inicio
            </Link>
            <Link
              onClick={() => setNavbarOpen(false)}
              to='/series'
              className={'p-2 bg-opacity-25 rounded-lg ' + (url.includes('series') && 'bg-red-2')}
            >
              <FontAwesomeIcon icon={faTv} size='xs' />
              &nbsp;&nbsp;Series
            </Link>
            <Link
              onClick={() => setNavbarOpen(false)}
              to='/peliculas'
              className={'p-2 bg-opacity-25 rounded-lg ' + (url.includes('peliculas') && 'bg-red-2')}
            >
              <FontAwesomeIcon icon={faFilm} size='xs' />
              &nbsp;&nbsp;Películas
            </Link>
            <Link
              onClick={() => setNavbarOpen(false)}
              to='/reglas'
              className={'p-2 bg-opacity-25 rounded-lg ' + (url.includes('reglas') && 'bg-red-2')}
            >
              <FontAwesomeIcon icon={faClipboardList} size='xs' />
              &nbsp;&nbsp;Reglas
            </Link>
            <Link
              onClick={() => setNavbarOpen(false)}
              to='/donaciones'
              className={'p-2 bg-opacity-25 rounded-lg ' + (url.includes('donaciones') && 'bg-red-2')}
            >
              <FontAwesomeIcon icon={faHandHoldingDollar} size='xs' />
              &nbsp;Donaciones
            </Link>

            {userData?.name && (
              <>
                <hr className='border-red-2 border-opacity-30' />
                <Link
                  onClick={() => setNavbarOpen(false)}
                  to='/perfil'
                  className={'p-2 bg-opacity-25 rounded-lg ' + (url.includes('perfil') && 'bg-red-2')}
                >
                  {userData.name}
                </Link>
                {userData.role === 'admin' && (
                  <Link
                    onClick={() => setNavbarOpen(false)}
                    to='/administracion'
                    className={'p-2 bg-opacity-25 rounded-lg ' + (url.includes('administracion') && 'bg-red-2')}
                  >
                    Administración
                  </Link>
                )}
                <button
                  onClick={() => {
                    setNavbarOpen(false);
                    logoutApi().finally(() => {
                      useUserStore.getState().logout();
                      window.location.href = '/';
                    });
                  }}
                  className='p-2 bg-opacity-25 rounded-lg text-left'
                >
                  Cerrar sesión
                </button>
              </>
            )}
          </div>
        </div>
      </div>
      {/* <div className='w-1/5'>test</div> */}
    </nav>
  );
};

Navbar.defaultProps = {
  className: '',
};

export default Navbar;
